<template>
  <div style="background-color: #fafafa;">
    <div style="margin-bottom:60px">
    <van-nav-bar
      title="盘点"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :z-index="998"
      fixed
    />
    <div class="box">
      <div>
        <p><span>商品编码：{{this.$route.params.codeName}}</span></p>
        <p><span>商品名称：{{this.$route.params.sukName}}</span></p>
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top:0;">
      <div v-if="isEnable === '11' && status === '1'" >
        <van-field type="text" label="" placeholder="请输入SN码" ref="SN" @keydown="keydownSN"  />
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text=""
      >
        <div
          v-for="data in list"
          class="card"
          :key="data.uuid"
        >
          <table v-if="isEnable === '11'" class="layout">
            <tr>
              <td colspan="2" class="content">
                <p>
                  <span>SN：</span>
                  <span>{{ data.barcodeIdname || "无" }}</span>
                </p>
                <p>
                  <span>货位条码：</span>
                  <span>{{ data.binIdname || "无" }}</span>
                </p>
                <p>
                  <span>扫码时间：</span>
                  <span>{{ data.createTime || "无" }}</span>
                </p>
              </td>
            </tr>
          </table>
          <table v-if="isEnable === '12'" >
            <tr>
            <td colspan="2" class="content">
              <p>
                <van-field  v-model="data.quantity" :disabled="disabled" type="number" label="数量：" placeholder="请输入数量"/>
                <van-field  v-model="data.binNumber" :disabled="disabled" type="string" label="货位：" placeholder="请输入货位" onblur=""/>
              </p>
            </td>
          </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-if="isEnable === '12' && status === '1'">
      <van-button
        style="height:30px;font-size: 14px;"
        type="info"
        size="large"
        @click="addRow()"
      >添加行</van-button>
    </div>
  </div>
    <div class="recordBox" v-if="status == '2'">
      <div
        style="display: flex;justify-content: center;align-items: center;"
      >
        <span>数量：{{this.number}}</span>
      </div>
    </div>
    <div class="recordBox"  v-else>
      <div
          style="display: flex;justify-content: space-between;align-items: center;"
      >
        <van-button
            style="height:30px;font-size: 14px;"
            type="info"
            size="large"
            @click="stockTakingComplete('1')"
        >保存</van-button
        >｜
        <van-button
            style="height:30px;font-size: 14px;"
            type="info"
            size="large"
            @click="stockTakingComplete('2')"
        >盘点完成</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Panel,
  Button,
  List,
  Search,
  Popup,
  PullRefresh,
  NavBar,
  Tag,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  DatetimePicker,
  Field,
  DropdownMenu,
  DropdownItem,
  Icon, Toast,
} from "vant";
import userInfo from "../../store/userInfo";
import stockTakingService from "../../service/stockTakingService";
// import moment from "moment";
import { formatDictionary } from "../../utils/dictionary";
import { API_URL } from "../../common/config";
import moment from "moment";
import electronicAllocationService from "../../service/electronicAllocationService";

export default {
  data: function() {
    return {
      list: [], //数据列表
      loading: false,
      finished: false, //数据加载完成
      pageIndex: 0, //第几页
      value: "", //搜索值
      refreshing: false, //是否刷新
      type: 2, //选项卡index
      isEnable: this.$route.params.isEnable,
      number:0, //数量
      status: this.$route.params.status, //上级盘点状态
      barcodeList:[],
      SN:"",
      disabled:this.$route.params.status==="1"?false:true,
    };
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    },
  },
  created: async function() {
    // eslint-disable-next-line no-console
    console.log(this.$route.params.uuid); //详情id
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await stockTakingService.getStockTakingCategorySkuBarcodeList(
        this.pageIndex,
        this.value,
        this.$route.params.uuid,
        this.$route.params.isEnable
      );
      if (resp.data.Status == "1" && resp.data.Data.data.length > 0) {
        // resp.data.Data.data.forEach((item) => {
        //   item.createTime = moment(item.createTime).format("YYYY-MM-DD");
        // });

        resp.data.Data.data.forEach((item) => {
          if(this.isEnable === "11"){
            this.number += 1;
          }else {
            this.number = item.number;
          }
        });

        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      }
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
      let r = await stockTakingService.getPsiBarcodeList (this.$route.params.uuid);
      if (r.data.Status == "1" && r.data.Data) {
        this.barcodeList = r.data.Data.data
      }
      if(this.$route.params.isEnable === '11'){
        this.$refs.SN.focus()
      }

    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    // openDetail(uuid) {
    //
    // },
    async scanBarcode() {
      if (this.inputBarcode == "" || this.inputBarcode == undefined) {
        Toast.fail("条码不能为空");
        return;
      }
      let a = false;
      for (let i = 0; i < this.list.length; i++) {
        const element = this.list[i];
        if (this.inputBarcode == element.barcode) {
          a = true;
        }
      }

      if (a) {
        Toast.fail("当前列表条码重复,请重新填写!");
        this.inputBarcode = "";
        this.inputBarcodeSkuId = "";
        this.$refs.inputBarcode.focus();
      } else {
        let resp = await electronicAllocationService.selectBarcodeAvailable(
          this.inputBarcode
        );
        if (resp.data.Status == "1" && resp.data.Data == "条码可用") {
          // 查询条码对应商品id
          let resp3 = await electronicAllocationService.getSkuIdByBarcode(
            this.inputBarcode
          );

          if (resp3.data.Status == "1" && resp3.data.Data) {
            this.inputBarcodeSkuId = resp3.data.Data;
          }
          let resp2 = await electronicAllocationService.getBinInfoByBarcode(
            this.inputBarcode
          );
          if (resp2.data.Status == "1" && resp2.data.Data) {
            for (let i = 0; i < this.list.length; i++) {
              const element = this.list[i];
              if (
                element.barcode == "" &&
                element.skuId == this.inputBarcodeSkuId
              ) {
                element.barcode = this.inputBarcode;
                element.binName = resp2.data.Data[0].binName;
                element.binId = resp2.data.Data[0].binName;
                this.quantity++;
                break;
              }
            }
            this.inputBarcode = "";
            this.inputBarcodeSkuId = "";
            this.$refs.inputBarcode.focus();
          } else {
            Toast.fail("没有查询到条码，或条码未入库");
            this.inputBarcode = "";
            this.inputBarcodeSkuId = "";
            this.$refs.inputBarcode.focus();
          }
        } else {
          Toast.fail(resp.data.Data);
          this.inputBarcode = "";
          this.inputBarcodeSkuId = "";
          this.$refs.inputBarcode.focus();
        }
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    addRow() {
      this.list.push({binNumber:"",quantity:""});
    },
    async stockTakingComplete(status) {
      let barcodeIds = "";
      this.list.forEach(item=>{
        if(barcodeIds!=""){
          barcodeIds += ",";
        }
        barcodeIds += item.barcodeId;
      })
      let resp = await stockTakingService.saveStocktaking(
          this.$route.params.uuid,
          barcodeIds,
          this.$route.params.isEnable,
          status,
          this.list,
          this.$route.params.stocktakingSkuNumber
      );
      if (resp.data.Status === '1') {
        this.status = status
        Toast.success('操作成功');
      } else {
        Toast.fail(resp.data.Message);
      }
    },
    keydownSN(){
      if(event.keyCode == 13){
        var _this = this
        const value = event.target.value;

        if(value){
          let s = false;
          this.list.forEach(item=>{
            if(item.barcodeIdname === value){
              s = true;
              return ;
            }
          })

          if(s){
            Toast.fail(value+" 已扫码")
            return ;
          }

          let c = false;
          this.barcodeList.forEach(item=>{
            if(item.barcodeIdname === value){
              c = true;
            }
          })
          if(!c){
            Toast.fail(value+" 不存在")
            return ;
          }
          this.barcodeList.forEach(item=>{
            if(item.barcodeIdname === value){
              _this.list.push({
                barcodeId:item.barcodeId,
                barcodeIdname:item.barcodeIdname,
                binIdname:item.binIdname,
                binId:item.binId,
                createTime:moment(new Date()).format('YYYY-MM-DD HH:mm:ss')})
                ++this.number;
            }
          })
        }
      }
    }
  },
};
</script>

<style>
.dropdownItem > .van-dropdown-item > .van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-nav-bar {
  z-index: 99999;
}
.van-icon {
  margin-right: 0.6rem;
  color: #4090fa;
}

.icon {
  margin-left: 1rem;
}
.recordBox {
  padding: 0.5rem 0.5rem;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
  background: #1989fa;
  color: #fff;
}
.box {
  padding: 0.5rem 0.5rem;
  box-sizing: border-box;
  margin-top: 3rem;
  bottom: 0;
  position: initial;
  width: 100%;
  background: #fff;
  color: #969799;
}
</style>
